var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-preview overlay"},[_c('font-awesome-icon',{staticClass:"close-button",attrs:{"icon":"times","size":"2x"},on:{"click":_vm.onClose}}),_c('img',{staticClass:"canvas-preview",attrs:{"src":_vm.imageUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }